<template>
  <v-card flat class="pa-6">
    <h5>ÄNDRINGSDATUM</h5>
    <v-row class="mx-0">
      <DatePicker
        v-model="instructions.committedAt"
        ref="datePicker"
        :icon="'$sl-calendar-date'"
        :width="'250'"
        outlined
        :required="false"
      />
      <v-btn class="icon mt-2 ml-6" @click="updateDate"> <v-icon>$sl-check</v-icon>SPARA ÄNDRINGSDATUM</v-btn>
    </v-row>

    <MessageBox class="mb-8" type="alert" v-if="dateUpdated">
      <p class="fontsize-14">
        Obs! Du har uppdaterat fältet för ändringsdatum av handledarinstruktionerna. Dina ändringar av datumet har ingen
        effekt om du inte väljer att spara.
      </p>

      <p class="fontsize-14">
        Om du sparar det uppdaterade ändringsdatumet innebär det att handledare på Mina sidor måste bekräfta
        handledarinstruktionerna på nytt.
      </p>
    </MessageBox>
    <h5>Sammanfattning av ändringar i aktuell publicerad version {{ initialCommitDate | date }}</h5>
    <p>
      Denna text visas i början av handledarinstruktionerna på Mina sidor. Den är tänkt att förenkla för handledare som
      redan tagit del av instruktionerna och enbart vill veta vad som förändrats sedan sist.
    </p>
    <p>
      Sammanfatta ändringarna i aktuell publicerad version på ett sånt sätt att en handledare kan förstå vad som ändrats
      utan att behöva läsa hela instruktionstexten.
    </p>
    <v-textarea outlined rows="4" v-model="instructions.commitMessage"></v-textarea>
    <p>
      Webbadresser som börjar på http eller https visas automatiskt som länkar. Använd asterisker (*) för att göra text
      *kursiv* eller **fet**. Använd bindestreck (-) i början av en rad för att skapa punktlistor.
    </p>

    <v-btn class="icon" @click="updateComment"> <v-icon>$sl-check</v-icon>SPARA SAMMANFATTNING AV ÄNDRINGAR</v-btn>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin} from '@/components/mixins'
import DatePicker from '@/components/common/DatePicker'
import MessageBox from '@/components/common/MessageBox.vue'
import SugarDate from 'sugar/date'

export default {
  name: 'EditCommit',

  components: {
    DatePicker,
    MessageBox
  },

  props: {
    tab: {
      type: Number,
      default: null
    }
  },

  data: () => ({
    instructions: {},
    initialCommitDate: null
  }),

  mixins: [RulesMixin],

  created() {
    this.init()
  },

  watch: {
    tab(newTab, oldTab) {
      if (newTab === 1) {
        this.init()
      }
    }
  },

  computed: {
    dateUpdated() {
      if (!this.initialCommitDate || !this.instructions.committedAt) {
        return false
      }
      if (SugarDate.Date(this.initialCommitDate).is(this.instructions.committedAt).raw) {
        return false
      }
      return true
    }
  },
  methods: {
    init() {
      API.getCurrentInstructions().then(({data}) => {
        this.instructions = data
        this.initialCommitDate = this.instructions.committedAt
      })
    },
    updateDate() {
      const data = {
        updateCommitted: true,
        committedAt: this.instructions.committedAt,
        commitMessage: this.instructions.commitMessage
      }
      API.updateInstructions(this.instructions.id, data).then(response => {
        this.$events.fire('showSuccess', 'Sparad')
      })
    },
    updateComment() {
      console.log('Update comment')
      const data = {
        updateCommitted: true,
        committedAt: this.initialCommitDate,
        commitMessage: this.instructions.commitMessage
      }
      API.updateInstructions(this.instructions.id, data).then(response => {
        this.$events.fire('showSuccess', 'Sparad')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>